const tableWraps = [];
const tables = [];

const checkTables = () => {
    tableWraps.forEach(tableWrap => {
        const tableWrapWidth = tableWrap.offsetWidth;
        const table = tableWrap.querySelector('table');
        const tableWidth = table.getAttribute('data-width');

        tableWidth > tableWrapWidth
            ? table.classList.add('no-table')
            : table.classList.remove('no-table');
    });
};

const addResizeEvent = () => {
    checkTables();

    window.addEventListener('resize', () => {
        checkTables();
    });
};

const setupResponsiveLabels = () => {
    tables.forEach(table => {
        const labels = table.querySelectorAll('thead th');
        const rows = table.querySelectorAll('tbody tr');

        rows.forEach(row => {
            const columns = row.querySelectorAll('td');

            columns.forEach((column, index) => {
                const label = labels[index].textContent.trim();

                if (label != '') {
                    column.setAttribute('data-label', labels[index].textContent);
                }
            });
        });
    });
};


export const setupResponsiveTables = () => {
    const mutationTargetNodes = document.querySelectorAll('.item_customrelatedproductlistview');

    if (mutationTargetNodes.length > 0) {
        const mutationConfig = { attributes: false, childList: true, subtree: true };

        mutationTargetNodes.forEach(targetNode => {
            const callback = mutationList => {
                for (const mutation of mutationList) {
                    if (mutation.type === 'childList') {
                        observer.observe(targetNode, mutationConfig);

                        const tableWrap = targetNode.querySelector('.item_customrelatedproductlistview .table-responsive');
                        const table = targetNode.querySelector('.item_customrelatedproductlistview .table-responsive table');

                        if (tableWrap !== undefined && table !== undefined) {
                            table.setAttribute('data-width', table.scrollWidth);

                            tableWraps.push(tableWrap);
                            tables.push(table);

                            setupResponsiveLabels();
                            addResizeEvent();
                        }

                        observer.disconnect();
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, mutationConfig);
        });
    }
};
